{
  "date": "{{day}} {{month}}, {{year}}",
  "docs": {
    "cpa": "Credit Profile Authorization",
    "esign": "E-Sign Consent",
    "pp": "Privacy Policy",
    "tos": "Terms of Use",
    "uplift": {
      "lendersLink": "https://uplift.com/lenders",
      "footnotes": "<div><span>By clicking \"Let's Get Started\", I agree to </span><esignLink /><span>, </span><cpaLink /><span>, </span><ppLink /><span>, and </span><tosLink /><span>.</span></div>",
      "please-ensure": "<div><span>Please ensure that the information you provided is your own. It will be used to verify your identity with third parties. Your rate of interest depends on credit score, loan amount and term, credit usage and history. All loans made by Uplift Canada Services ULC. For more information, see the <tosLink /> and <ppLink />.</span></div>"
    },
    "flexpay": {
      "lendersLink": "https://upgrade.com/flex-pay/lenders",
      "footnotes": "<div><span>By clicking \"Let's Get Started\", I agree to </span><esignLink /><span>, </span><cpaLink /><span>, </span><ppLink /><span>, and </span><tosLink /><span>. I also authorize Upgrade and its subsidiaries to obtain my consumer credit report to present me with potential loan offers.</span></div>",
      "please-ensure": "<div><span>Please ensure that the information provided is complete and accurate. It will be used to verify your identity. Your rate depends upon credit score, loan amount and term, credit usage and history. Loans made through Flex Pay by Upgrade are offered by these lending partners:</span> <lendersLink>upgrade.com/flex-pay/lenders</lendersLink><span>.</span></div>"
    }
  },
  "read-only-labels": {
    "name": "Applicant",
    "phone-number": "Mobile Number",
    "email": "Email",
    "trip-dates": "Trip Dates",
    "trip-date": "Trip Date",
    "purchase-cost": "Purchase Cost"
  },
  "subvention-promo": "As low as 0% APR may be available",
  "estimated-payment": {
    "header": "Estimated payment",
    "from-payment": "from <payment />/month",
    "apr": "<span>Estimated calculation based on <apr /> APR, a first payment today from <downpayment />, followed by <numberofpayments>{{numberOfPayments}}</numberofpayments> loan payments.</span>"
  },
  "required-fields": "All fields required",
  "regular-application": {
    "inputs": {
      "first_name": {
        "label": "First Name",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "is required*"],
          ["minLength2", "is required*"],
          ["validName", "is invalid*"]
        ]
      },
      "last_name": {
        "label": "Last Name",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "is required*"],
          ["minLength2", "is required*"],
          ["validName", "is invalid*"]
        ]
      },
      "address": {
        "label": "Home Address",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "Home Address is required*", "ignore label"],
          ["minLength2", "Home Address is invalid*", "ignore label"],
          ["notEmail", "Home Address is invalid*", "ignore label"],
          ["notPOBox", "PO Box is not accepted*", "ignore label"]
        ]
      },
      "city": {
        "label": "City*",
        "isRequired": true,
        "validity": [
          ["required", "City is required*", "ignore label"],
          ["minLength2", "City is invalid*", "ignore label"],
          ["notEmail", "City is invalid*", "ignore label"]
        ]
      },
      "region": {
        "label": "Province*",
        "isRequired": true,
        "placeholder": "Select Province",
        "validity": [
          ["required", "Province is required*", "ignore label"],
          ["minLength2", "Province is invalid*", "ignore label"],
          ["validRegionCA", "Province is invalid*", "ignore label"]
        ]
      },
      "postal_code": {
        "label": "Postal Code*",
        "isRequired": true,
        "mask": "A0A 0A0",
        "placeholder": "55555",
        "validity": [
          ["required", "Postal Code is required*", "ignore label"],
          ["minLength6", "Postal Code is invalid*", "ignore label"]
        ],
        "postProcess": "digitCharOnlyString"
      },
      "date_of_birth": {
        "label": "Date of Birth",
        "isRequired": true,
        "showRequiredIcon": true,
        "mask": "00/00/0000",
        "maxLength": "10",
        "format": "ddmmyyyy",
        "placeholder": "dd/mm/yyyy",
        "srOnly": "D D M M Y Y Y Y",
        "tooltip": "<div><span>Applicant must be 19 years or older.</span></div>",
        "validity": [
          ["required", "is required*"],
          ["minLength8", "is invalid*"],
          ["validDate", "is invalid*"],
          ["isNotUnderageCA", "Must be 19+ years old*", "ignore label"],
          ["validBirthdate", "Enter a valid birth date*", "ignore label"]
        ],
        "postProcess": "reformatDateOfBirthCA"
      },
      "income": {
        "label": "Gross Annual Income",
        "maxLength": "10",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "$50,000",
        "symbol": "$",
        "validity": [
          ["validAmount", "Enter a valid income figure*", "ignore label"]
        ],
        "postProcess": "priceInCents",
        "tooltip": "<div><span>Includes your household income before income tax rounded to the nearest dollar.</span></div>"
      },
      "email": {
        "label": "Email",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "is required*"],
          ["validEmail", "is invalid*"]
        ]
      },
      "mobile": {
        "label": "Mobile Number",
        "isRequired": true,
        "showRequiredIcon": true,
        "tooltip": "<span>We need this to send you a</span><br><span>one-time SMS verification code.</span>",
        "mask": "000-000-0000",
        "placeholder": "555-555-5555",
        "validity": [
          ["required", "is required*"],
          ["requiredLength10", "is invalid*"]
        ],
        "postProcess": "digitOnlyString"
      },
      "monthly_housing_cost": {
        "label": "Monthly Housing Cost",
        "maxLength": "10",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "$1,000",
        "symbol": "$",
        "validity": [["required", "is required*"]],
        "postProcess": "priceInCents"
      },
      "primary_income_source": {
        "label": "Primary Source of Income",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "Select an option",
        "validity": [["required", "is required*"]]
      },
      "occupation": {
        "label": "Occupation",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [["required", "is required*"]]
      },
      "employment_duration": {
        "label": "Duration with Current Employer",
        "placeholder": "Select an option",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [["required", "is required*"]]
      }
    },
    "header": "<h2>Ready to check your rate?</h2>",
    "header-with-name": "<h2>Hi {{name}}, ready to check your rate?</h2>",
    "subheader": {
      "verify-details": "Please verify the details below are correct.",
      "no-inquiry": "Checking eligibility won't affect your credit score.",
      "learn-more": "Learn more"
    }
  },
  "incomeSources": {
    "salaried": "Salaried",
    "self-employed": "Self Employed",
    "investments": "Investments",
    "other": "Other"
  },
  "employmentDurations": {
    "<1": "Less than 1 year",
    "1-2": "1 - 2 years",
    "3-5": "3 - 5 years",
    ">5": "Over 5 years"
  },
  "uplift": {
    "marketing-communication-opt-in": "Yes, I'd like to receive information about new offers and deals from Uplift."
  },
  "flexpay": {
    "marketing-communication-opt-in": "Yes, I'd like to receive information about new offers and deals from Flex Pay."
  },
  "submit": "Let's Get Started"
}
